import React from 'react';
import { Form, Button, Spinner, Row, Col, ButtonGroup } from 'react-bootstrap';
import { useSearch } from '../context/SearchContext';
import { useTheme } from '../context/ThemeContext';
import { FaSun, FaMoon, FaDesktop } from 'react-icons/fa';
import HelpGuide from './HelpGuide';

function SettingsSection() {
  const { theme, setTheme } = useTheme();

  return (
    <>
      <div className="mb-4">
        <h5 className="mb-3">Theme</h5>
        <ButtonGroup>
          <Button
            variant={theme === 'light' ? 'primary' : 'outline-primary'}
            onClick={() => setTheme('light')}
            title="Light Theme"
          >
            <FaSun className="me-2" />
            Light
          </Button>
          <Button
            variant={theme === 'dark' ? 'primary' : 'outline-primary'}
            onClick={() => setTheme('dark')}
            title="Dark Theme"
          >
            <FaMoon className="me-2" />
            Dark
          </Button>
          <Button
            variant={theme === 'system' ? 'primary' : 'outline-primary'}
            onClick={() => setTheme('system')}
            title="Follow System"
          >
            <FaDesktop className="me-2" />
            System
          </Button>
        </ButtonGroup>
        <Form.Text className="text-muted d-block mt-2">
          Choose your preferred theme. "System" will automatically match your system's theme preference.
        </Form.Text>
      </div>
      <HelpGuide />
    </>
  );
}

export default SettingsSection;
